import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconicModule } from '../iconic/iconic.module';
import { CheckBoxComponent, CheckBoxLabelTemplate } from './check-box.component';

@NgModule({
  imports: [CommonModule, IconicModule],
  declarations: [CheckBoxComponent, CheckBoxLabelTemplate],
  exports: [CheckBoxComponent, CheckBoxLabelTemplate],
})
export class CheckBoxModule {}
